import { render, staticRenderFns } from "./menuReportsActions.vue?vue&type=template&id=d1e2751c&"
import script from "./menuReportsActions.vue?vue&type=script&lang=js&"
export * from "./menuReportsActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports